var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-preview-body" }, [
    _c(
      "div",
      { staticClass: "comment-detail__header" },
      [
        _c("img", {
          directives: [
            {
              name: "region-img-src",
              rawName: "v-region-img-src",
              value: "email-logo-hkland.png",
              expression: "'email-logo-hkland.png'",
            },
          ],
          staticClass: "hkld-logo",
          attrs: { alt: "Hongkong Land" },
        }),
        _vm._v(" "),
        _vm._t("recipientsSlot"),
        _vm._v(" "),
        _vm.greeting
          ? _c("div", { staticClass: "greeting section-mgn-btm" }, [
              _vm._v("\n      " + _vm._s(_vm.greeting) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("additionalInfoSlot"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "consolidated-comment comment-detail__content section-mgn-btm email-preview__content",
      },
      [
        _vm.description
          ? _c("div", { staticClass: "comment-content description" }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.description) } }),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }